module.exports = __webpack_public_path__ + "img/classroom_listeners_514x500.841c4224.jpg";